import React from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';

import {$doesInvoiceExist} from 'models/documents/invoices/common';

import {ModalContent, ModalMessage, ModalButtons} from './styled';

interface Props {
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmNavigationModal: React.FC<Props> = ({show, onConfirm, onCancel}) => {
    const {t} = useTranslation();
    const doesInvoiceExist = useStore($doesInvoiceExist);

    const EXISTING_PATH = 'pages.documents.invoices.confirmNavigationModalExisting';
    const NEW_PATH = 'pages.documents.invoices.confirmNavigationModalNew';
    const title = doesInvoiceExist ? t(`${EXISTING_PATH}.title`) : t(`${NEW_PATH}.title`);
    const message = doesInvoiceExist ? t(`${EXISTING_PATH}.message`) : t(`${NEW_PATH}.message`);
    const confirm = doesInvoiceExist ? t(`${EXISTING_PATH}.confirm`) : t(`${NEW_PATH}.confirm`);
    const cancel = doesInvoiceExist ? t(`${EXISTING_PATH}.cancel`) : t(`${NEW_PATH}.cancel`);
    return (
        <Modal
            show={show}
            onClose={onCancel}
            closable={false}
            hideCloseButton={true}
            modalWidth={0}
            title={title}
        >
            <ModalContent>
                <ModalMessage>{message}</ModalMessage>
                <ModalButtons>
                    <Button variant={ButtonVariant.Outline} onClick={onConfirm}>
                        {confirm}
                    </Button>
                    <Button variant={ButtonVariant.Normal} onClick={onCancel}>
                        {cancel}
                    </Button>
                </ModalButtons>
            </ModalContent>
        </Modal>
    );
};
